import { NgModule } from "@angular/core";
import { EffectsModule } from "@ngrx/effects";
import { StoreModule, createSelector } from "@ngrx/store";
import { helperValues } from "app/store/common/commonStore.module";
import { DocumentSignatureEffect } from "./effect";
import { DocumentSignatureReducer } from "./reducer";

@NgModule({
  imports: [
    EffectsModule.forFeature([DocumentSignatureEffect]),
    StoreModule.forFeature("documentSignature", DocumentSignatureReducer),
  ],
})
export class DocumentSignatureStoreModule {}

export const documentSignatureList = (store: any) =>
  store &&
  store.documentSignature &&
  store.documentSignature.documentSignatureList;
export const documentSignatureByFieldList = (store: any) =>
  store &&
  store.documentSignature &&
  store.documentSignature.documentSignatureByFieldList;
export const documentSignatureById = (store: any) =>
  store &&
  store.documentSignature &&
  store.documentSignature.documentSignatureById;
export const saveDocumentSignatureResp = (store: any) =>
  store &&
  store.documentSignature &&
  store.documentSignature.saveDocumentSignatureResp;
export const updateDocumentSignatureResp = (store: any) =>
  store &&
  store.documentSignature &&
  store.documentSignature.updateDocumentSignatureResp;
export const deleteDocumentSignatureResp = (store: any) =>
  store &&
  store.documentSignature &&
  store.documentSignature.deleteDocumentSignatureResp;
export const resendDocumentSignatureResp = (store: any) =>
  store &&
  store.documentSignature &&
  store.documentSignature.resendDocumentSignatureResp;

export const refreshDocumentSignatureResp = (store: any) =>
  store &&
  store.documentSignature &&
  store.documentSignature.refreshSignatureStatus;

export const documentSignatureListWithStatusAndType = createSelector(
  documentSignatureByFieldList,
  helperValues,
  (list, values) => {
    const status = values?.documentSignStatus || [];
    const docType = values?.signDocumentType || [];
    const docModule = values?.documentSignModule || [];
    const listContent = list?.content || [];
    return {
      ...list,
      content: listContent.map((item: any) => {
        const signStatusId = item.documentDetails?.signStatus;
        const docTypeId = item.documentType;
        const docModuleId = item.documentSignModule;
        return {
          ...item,
          documentSignModuleName:
              docModule.find(({ id }) => id === docModuleId)?.name || "-",
          documentTypeName:
              docType.find(({ id }) => id === docTypeId)?.name || "-",
          documentDetails: {
            ...item.documentDetails,
            signStatusName:
                status.find(({ id }) => id === signStatusId)?.name || "-",
          },
        };
      }),
    };
  }
);
